import { render, staticRenderFns } from "./SelectStretches.vue?vue&type=template&id=15fa787c&scoped=true&"
import script from "./SelectStretches.vue?vue&type=script&lang=js&"
export * from "./SelectStretches.vue?vue&type=script&lang=js&"
import style0 from "./SelectStretches.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SelectStretches.vue?vue&type=style&index=1&id=15fa787c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fa787c",
  null
  
)

/* custom blocks */
import block0 from "./SelectStretches.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports